'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRouter = require('react-router');
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxPagan = require('redux-pagan');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _InviteStaffPage = require('./InviteStaffPage.scss');var styles = _interopRequireWildcard(_InviteStaffPage);

var _myStaff = require('../../redux/modules/myStaff');
var _userAuthentication = require('../../redux/modules/userAuthentication');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
// Redux
var InviteStaffPage = function (_React$Component) {_inherits(InviteStaffPage, _React$Component);function InviteStaffPage() {_classCallCheck(this, InviteStaffPage);return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));}InviteStaffPage.prototype.componentDidMount = function componentDidMount() {
    this.props.joinAgencyInvitation({
      token: this.props.userToken,
      invitationId: this.props.routeParams.id });

  };InviteStaffPage.prototype.

  componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo && nextProps.redirectTo !== this.props.redirectTo) {
      var route = void 0;
      switch (nextProps.redirectTo) {
        case 'SIGN_IN':
          this.props.logOut().then(function () {
            window.location.href = '/he/sign-in';
          });
          break;
        case 'PROFILE':
          route = '/he/profile/edit';
          break;
        case 'INVITATION_EXPIRED':
          route = '/he/invitation_expired';
          break;
        default:
          route = '/';
          break;}

      if (route) {
        _reactRouter.browserHistory.push(route);
      }
    }
  };InviteStaffPage.prototype.

  render = function render() {var
    translate = this.props.translate;
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.notFoundWrapper, 'pageHeight') },
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: translate('title', 'titleTemplate')(),
          title: translate('InviteStaffPage', 'title')() }),

        _react2.default.createElement('div', { className: styles.content },
          _react2.default.createElement('h1', null, translate('InviteStaffPage', 'pleaseWait')))));



  };return InviteStaffPage;}(_react2.default.Component);


InviteStaffPage.propTypes = {
  route: _propTypes2.default.string,
  redirectTo: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  routeParams: _propTypes2.default.object,
  joinAgencyInvitation: _propTypes2.default.func.isRequired,
  logOut: _propTypes2.default.func.isRequired };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
    redirectTo: (0, _get2.default)(state, 'myStaff.redirectTo', null) };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, {
  joinAgencyInvitation: _myStaff.joinAgencyInvitation,
  logOut: _userAuthentication.logOut })(

InviteStaffPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/InviteStaff/InviteStaffPage.js
// module id = 3111
// module chunks = 0